import React, { useState } from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Button as AntdButton, message as AntdMessage } from 'antd';

import ModalCreation from '../../Creation/ModalCreation';
import { LONG_DELAY } from '../constants';
import Filter from '../Filter';

import { FilterDashboardComptesUtilisateurs } from './types';

import './DashboardHeader.less';

interface DashboardHeaderProps {
  totalResult: number;
  setFilter: (value: Partial<FilterDashboardComptesUtilisateurs>) => void;
  filter: Partial<FilterDashboardComptesUtilisateurs>;
}

function DashboardHeader({
  totalResult,
  filter,
  setFilter,
}: DashboardHeaderProps): React.ReactElement {
  const countString = `${totalResult} ${
    totalResult > 1 ? 'comptes utilisateurs' : 'compte utilisateur'
  }`;

  const [modalCreationOpen, setModalCreationOpen] = useState<boolean>(false);

  const openModal = () => {
    setModalCreationOpen(true);
  };

  const closeModal = () => {
    setModalCreationOpen(false);
  };

  return (
    <div>
      <div className="dashboard-header-fields">
        <Filter filter={filter} setFilter={setFilter} />
        <AntdButton
          icon={<PlusOutlined />}
          type={'primary'}
          shape={'round'}
          onClick={openModal}
        >
          Créer un nouveau compte
        </AntdButton>
        <ModalCreation
          close={closeModal}
          callAfterSubmit={(result, email) => {
            let successMessage = `Le compte ${result.username} a été créé avec succès.`;
            if (email) {
              successMessage += ` Un courriel d'initialisation de compte a été automatiquement envoyé à ${email}.`;
            }
            void AntdMessage.success(successMessage, LONG_DELAY);
            setFilter({
              ...filter,
            });
          }}
          visible={modalCreationOpen}
        />
      </div>
      <p>{countString}</p>
    </div>
  );
}

export default DashboardHeader;
